module.exports = require("@swa-ui/placements/src/BannerGrid/BannerGridLayout1.module.scss");